import * as React from 'react';

import { LinkButton, SkeletonGroup, UIHeading2 } from '@cian/ui-kit';
import { useInView } from '@cian/valuation-utils-component';

import * as styles from './RecommendationsList.css';
import { useVisitedOffersContext } from '@cian/frontend-visited-offers-widget';
import clsx from 'clsx';

export interface IRecommendationsList {
  withHeader: boolean;
  withBottomMargin?: boolean;
  onShow?(): void;
  onMoreClick?(): void;
  children: React.ReactNode;
}

export const RecommendationsList: React.FC<IRecommendationsList> = ({
  onShow,
  withHeader,
  withBottomMargin,
  children,
  onMoreClick,
}) => {
  const [isShown, setIsShown] = React.useState(false);
  const { isLoaded: isVisitedOffersLoaded } = useVisitedOffersContext();

  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true,
  });

  React.useEffect(() => {
    if (inView && onShow && !isShown && isVisitedOffersLoaded) {
      onShow();
      setIsShown(true);
    }
  }, [inView, onShow, isShown, isVisitedOffersLoaded]);

  return (
    <div ref={ref} data-recommendations-grid>
      {withHeader && <UIHeading2>Могут подойти</UIHeading2>}
      <SkeletonGroup
        scope="group"
        cols={2}
        gap={[24, 16]}
        className={clsx(styles['list'], withBottomMargin ? styles['bottom-margin'] : undefined)}
      >
        {children}
      </SkeletonGroup>
      {onMoreClick && (
        <LinkButton
          data-name="MoreLink"
          size="M"
          theme="fill_secondary"
          fullWidth
          onClick={onMoreClick}
          href="/recommendations/"
        >
          Ещё объявления
        </LinkButton>
      )}
    </div>
  );
};
